import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTheme } from 'emotion-theming';
import { Theme } from '@/theme';
import Icon from '../Icon/Icon';
import useMode from '../../hooks/useMode';

type Props = {
  readonly name: string;
  readonly collapsed?: boolean;
};

/** Profile link in the sidebar footer. Shows icon-only when collapsed. */
const SidebarProfileLink = ({ name, collapsed }: Props): JSX.Element => {
  const theme = useTheme<Theme>();
  const mode = useMode();

  if (collapsed) {
    return (
      <NavLink
        to={`/${mode}/profile`}
        aria-label={name}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          color: theme.colors.onNavbar,
          padding: theme.space[1],
        }}
      >
        <Icon icon="person" size={18} />
      </NavLink>
    );
  }

  return (
    <NavLink
      to={`/${mode}/profile`}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: theme.space[2],
        textDecoration: 'none',
        padding: 0,
        border: 'none',
        fontSize: theme.fontSizes[1],
        color: theme.colors.onNavbar,
        fontWeight: theme.fontWeights.heading,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flexGrow: 1,
      }}
      activeStyle={{
        color: theme.colors.onNavbarHover,
      }}
    >
      <Icon icon="person" size={16} style={{ flexShrink: 0 }} />
      {name}
    </NavLink>
  );
};

export default SidebarProfileLink;
